import { BaseUrl, NewUpdatedBaseUrl } from "../../BaseUrl/BaseUrl";
import {
    postApiWithAuthorization,
    getApiWithAuthorization,
} from "../ApiMethod/ApiMethod";

export const GetOrderTrackingDetails = async (UserID, OrderID, Type) => {
    const url = `${BaseUrl}/BookingTrack/GetOrderTrackingDetails?UserID=${UserID}&OrderID=${OrderID}&Type=${Type}`;
    const res = await getApiWithAuthorization(url);

    return res;
};
export const GetProductOrderTrackingDetails = async (EstoreBookingKeyID, UserKeyID,AppLangID) => {
    const url = `${NewUpdatedBaseUrl}/Product/GetProductOrderTrackingDetails?EstoreBookingKeyID=${EstoreBookingKeyID}&UserKeyID=${UserKeyID}&AppLangID=${AppLangID}`;
    const res = await getApiWithAuthorization(url);

    return res;
};

